module.exports = __webpack_public_path__ + "static/img/7.67b75f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/zh/7.png
// module id = zXf5
// module chunks = 0